import { updateStoryMeta } from "../dataStories/storiesApi";
import type { StoryAutoRefreshState } from "./storyAutoRefresh.types";

/**
 * Proxies onto the story PATCH (`updateStoryMeta`) rather than a dedicated
 * auto-refresh endpoint — per backend, `is_auto_refresh` lives on the same
 * story resource as `title`. Merge-patch, so only the flag is sent.
 *
 * There is no read here: `is_auto_refresh` comes off the story GET
 * (`useStoryMeta`), which the page already loads.
 */
export const setStoryAutoRefresh = async (
  workspaceId: string,
  storyId: string,
  enabled: boolean,
): Promise<StoryAutoRefreshState> => {
  const story = await updateStoryMeta(workspaceId, storyId, {
    is_auto_refresh: enabled,
  });
  return { storyId: story.id, enabled: story.is_auto_refresh };
};
